var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.Prompt"),
        width: "400px",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            "text-align": "center"
          }
        },
        [
          _c("span", { staticStyle: { "line-height": "40px" } }, [
            _vm._v(_vm._s(_vm.resultMsg))
          ])
        ]
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "30px" },
              attrs: { type: "primary", no: "1" },
              on: {
                click: function($event) {
                  return _vm.continueImporting()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.ContinueImporting")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "30px" },
              attrs: { type: "primary", no: "2" },
              on: {
                click: function($event) {
                  return _vm.downloadResultLog()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.DownloadResultLog")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }